export default __webpack_public_path__ + "static/media/Digital Keys.39c312c8.svg";